// Sunrich price list, migrated from the old POS on 14 Aug 2026.
// Prices change occasionally — update here when Sunrich issues a new list.
export interface SunrichItem {
  name: string;
  price: number;
  group: string;
}

export const SUNRICH_CATALOGUE: SunrichItem[] = [
  { name: "SUNRICH SELF RAISING FLOUR 20X1KG", price: 320, group: "Flour & mixes" },
  { name: "SUNRICH SELF RAISING FLOUR 1KG", price: 16, group: "Flour & mixes" },
  { name: "SUNRICH SELF RAISING 8X2.5KG", price: 320, group: "Flour & mixes" },
  { name: "SUNRICH SELF RAISING 2.5KG", price: 40, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 8X2.5KG", price: 270, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 2.5KG", price: 34, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 4X5KG", price: 240, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 5KG", price: 60, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 10KG", price: 110, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 12.5KG", price: 140, group: "Flour & mixes" },
  { name: "SUNRICH CAKE 25KG", price: 280, group: "Flour & mixes" },
  { name: "SUNRICH BROWN 12.5KG", price: 132, group: "Flour & mixes" },
  { name: "SUNRICH BROWN 25KG", price: 270, group: "Flour & mixes" },
  { name: "SUNRICH WHITE 12.5KG", price: 135, group: "Flour & mixes" },
  { name: "SUNRICH WHITE 25KG", price: 275, group: "Flour & mixes" },
  { name: "SUNRICH COMPLETE WHITE 12.5KG", price: 161, group: "Flour & mixes" },
  { name: "SUNRICH COMPLETE BROWN 12.5KG", price: 156, group: "Flour & mixes" },
  { name: "SUNRICH COMPLETE SOFT & SWEET 12.5KG", price: 185, group: "Flour & mixes" },
  { name: "SUNRICH SUPER MAIZE MEAL 5KG", price: 42, group: "Flour & mixes" },
  { name: "SUNRICH SUPER MAIZE MEAL 10KG", price: 80, group: "Flour & mixes" },
  { name: "SUNRICH SUPER MAIZE MEAL 12.5KG", price: 100, group: "Flour & mixes" },
  { name: "SUNRICH SUPER MAIZE MEAL 25KG", price: 195, group: "Flour & mixes" },
  { name: "WHITE SUGAR 25KG", price: 520, group: "Sugar" },
  { name: "WHITE SUGAR 10KG", price: 220, group: "Sugar" },
  { name: "BROWN SUGAR 25KG", price: 480, group: "Sugar" },
  { name: "BROWN SUGAR 5KG", price: 105, group: "Sugar" },
  { name: "BROWN SUGAR 10KG", price: 200, group: "Sugar" },
  { name: "RICE 5KG", price: 55, group: "Groceries" },
  { name: "RICE 10KG", price: 105, group: "Groceries" },
  { name: "RICE 25KG", price: 250, group: "Groceries" },
  { name: "VICTORIA BOX", price: 860, group: "Groceries" },
  { name: "VICTORIA 500G", price: 50, group: "Groceries" },
  { name: "NCP BOX", price: 860, group: "Groceries" },
  { name: "NCP 500G", price: 45, group: "Groceries" },
  { name: "SUNRICH PREMIX 4.5%", price: 425, group: "Flour & mixes" },
  { name: "SUNRICH PREMIX 5%", price: 500, group: "Flour & mixes" },
  { name: "SUNRICH PREMIX 15%", price: 550, group: "Flour & mixes" },
  { name: "SUNRICH PREMIX 20%", price: 530, group: "Flour & mixes" },
  { name: "SUNRICH SPONGE MIX 25KG", price: 780, group: "Flour & mixes" },
  { name: "SUNRICH MUFFIN MIX 12.5KG", price: 275, group: "Flour & mixes" },
  { name: "IMPROVER 1KG", price: 80, group: "Flour & mixes" },
  { name: "DI BELLA WATER 24X500ML", price: 90, group: "Groceries" },
  { name: "DI BELLA WATER 24X750ML", price: 115, group: "Groceries" },
  { name: "DI BELLA WATER 12X1.5L", price: 90, group: "Groceries" },
  { name: "DI BELLA WATER 4X5L", price: 60, group: "Groceries" },
  { name: "HENTIES APPLE JUICE 250ML - 6 PACK", price: 30, group: "Groceries" },
  { name: "HENTIES MANGO JUICE 250ML - 6 PACK", price: 30, group: "Groceries" },
  { name: "HENTIES BERRY JUICE 250ML - 6 PACK", price: 30, group: "Groceries" },
  { name: "HENTIES ORANGE JUICE 250ML - 6 PACK", price: 30, group: "Groceries" },
  { name: "NOODLES CHICKEN 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES BEEF 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES TSHISA NYAMA 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES STEAK & CHOPS 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES DURBAN CURRY 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES CHEESE 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES SEAFOOD 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES HOT & SPICY 10X5X70G", price: 135, group: "Groceries" },
  { name: "NOODLES VEGETABLE 10X5X70G", price: 135, group: "Groceries" },
  { name: "PALM OIL 20L", price: 590, group: "Fats & oils" },
  { name: "FLAMENCO 20L", price: 600, group: "Baking ingredients" },
  { name: "PAN OIL 20L", price: 355, group: "Fats & oils" },
  { name: "YELLOW MARGARINE 25KG", price: 800, group: "Fats & oils" },
  { name: "WHITE MARGARINE 25KG", price: 800, group: "Fats & oils" },
  { name: "BREAD SPREAD 20KG", price: 440, group: "Fats & oils" },
  { name: "BREAD PLASTIC 1000'S", price: 225, group: "Packaging & sundries" },
  { name: "OVEN GLOVES", price: 72, group: "Packaging & sundries" },
  { name: "VANILLA ESS 1L", price: 50, group: "Baking ingredients" },
  { name: "BANANA PASTE 1L", price: 60, group: "Baking ingredients" },
  { name: "LEMON PASTE 1L", price: 60, group: "Baking ingredients" },
  { name: "COCOA POWDER 1KG", price: 300, group: "Baking ingredients" },
  { name: "COCONUT 1KG", price: 110, group: "Baking ingredients" },
  { name: "BICARB 1KG", price: 30, group: "Baking ingredients" },
  { name: "BAKING POWDER 1KG", price: 60, group: "Baking ingredients" },
  { name: "CORN FLOUR", price: 30, group: "Flour & mixes" },
  { name: "CUSTARD POWDER 1KG", price: 45, group: "Baking ingredients" },
  { name: "EGG YELLOW 1KG", price: 80, group: "Baking ingredients" },
  { name: "GINGER 1KG", price: 160, group: "Baking ingredients" },
  { name: "CINNAMON 1KG", price: 100, group: "Baking ingredients" },
  { name: "ANISEED 1KG", price: 190, group: "Baking ingredients" },
  { name: "100'S & 1000'S 1KG", price: 100, group: "Baking ingredients" },
  { name: "SUNFLOWER SEEDS 1KG", price: 70, group: "Baking ingredients" },
  { name: "SESAME SEEDS 1KG", price: 80, group: "Baking ingredients" },
  { name: "ICING SUGAR 500G", price: 20, group: "Sugar" },
  { name: "ICING SUGAR 1KG", price: 35, group: "Sugar" },
  { name: "ICING 25KG", price: 600, group: "Sugar" },
  { name: "CASTOR SUGAR 1KG", price: 30, group: "Sugar" },
  { name: "CARAMEL SPREAD 3KG", price: 280, group: "Fats & oils" },
  { name: "VERMICELLI RAINBOW 1KG", price: 100, group: "Baking ingredients" },
  { name: "VERMICELLI RAINBOW 5KG", price: 480, group: "Baking ingredients" },
  { name: "VERMICELLI CHOCOLATE 1KG", price: 100, group: "Baking ingredients" },
  { name: "VERMICELLI CHOCOLATE 5KG", price: 480, group: "Baking ingredients" },
  { name: "WHOLE RED CHERRIES 5KG", price: 1130, group: "Baking ingredients" },
  { name: "BLACK FOREST TOPPING 6KG", price: 270, group: "Baking ingredients" },
  { name: "BLUEBERRY TOPPING 6KG", price: 270, group: "Baking ingredients" },
  { name: "STRAWBERRY TOPPING 6KG", price: 270, group: "Baking ingredients" },
  { name: "GRANADILLA TOPPING 6KG", price: 320, group: "Baking ingredients" },
  { name: "RAISIN MIX 12KG", price: 370, group: "Baking ingredients" },
  { name: "PEANUT BUTTER 500G", price: 40, group: "Baking ingredients" },
  { name: "PEANUT BUTTER 1KG", price: 70, group: "Baking ingredients" },
  { name: "ASSORTED BUCKET BISCUITS 4KG", price: 100, group: "Baking ingredients" },
];
